import { render, staticRenderFns } from "./CsAsignacionesDetCarga.vue?vue&type=template&id=16aa0117"
import script from "./CsAsignacionesDetCarga.vue?vue&type=script&lang=js"
export * from "./CsAsignacionesDetCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports